import { render } from "./DescriptionDetails.vue?vue&type=template&id=956a5ad6"
import script from "./DescriptionDetails.vue?vue&type=script&lang=js"
export * from "./DescriptionDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__